(function () {
  'use strict';
  if (window.ylApp) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var inr = function (c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); };
  var inrR = function (r) { return inr(r * 100); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function eta(days) {
    var d = new Date(), n = 0;
    while (n < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n++; }
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  var ETA_DAYS = 5;
  function paintEta() { var t = eta(ETA_DAYS); $$('[data-ya-eta]').forEach(function (e) { e.textContent = t; }); }

  function setCount(n) {
    $$('[data-ya-count]').forEach(function (b) { b.textContent = n; b.hidden = !(n > 0); });
    $$('.ylh__cart-count').forEach(function (b) { b.textContent = n; });
  }
  var api = window.ylApp = { eta: eta, inr: inr, setCount: setCount, store: store, etaDays: ETA_DAYS, cart: null, onCart: [] };
  api.setCart = function (c) { api.cart = c; setCount(c.item_count); api.onCart.forEach(function (f) { try { f(c); } catch (e) {} }); };
  api.refresh = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { api.setCart(c); return c; }); };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ya-back]');
    if (!b) return;
    e.preventDefault();
    if (history.length > 1 && document.referrer.indexOf(location.host) > -1) history.back(); else location.href = b.getAttribute('data-fallback') || '/';
  });

  var scrim = $('[data-ya-scrim]');
  function openSheet(id) { var s = document.getElementById(id); if (!s) return; scrim.classList.add('is-on'); s.classList.add('is-on'); s.setAttribute('aria-hidden', 'false'); }
  function closeSheets() { $$('.ya-sheet.is-on').forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-hidden', 'true'); }); if (scrim) scrim.classList.remove('is-on'); }
  api.openSheet = openSheet; api.closeSheets = closeSheets;
  document.addEventListener('click', function (e) { if (e.target.closest('[data-ya-close]') || e.target === scrim) closeSheets(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });

  function addToCart(id, quiet, props) {
    window.__yaQuiet = !!quiet;
    var item = { id: id, quantity: 1 }; if (props) item.properties = props;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }); })
      .then(function (j) { return api.refresh().then(function () { window.__yaQuiet = false; return j; }); })
      .catch(function (err) { window.__yaQuiet = false; alert(err.message); });
  }
  api.addToCart = addToCart;

  var qa = { data: null, vid: null, btn: null };
  function renderQA() {
    var d = qa.data, s = $('#yaQA'); if (!d || !s) return;
    $('[data-qa-img]', s).src = d.i; $('[data-qa-name]', s).textContent = d.t; $('[data-qa-sub]', s).textContent = d.s || '';
    $('[data-qa-price]', s).innerHTML = inr(d.p) + (d.c > d.p ? ' <s>' + inr(d.c) + '</s>' : '');
    var wrap = $('[data-qa-sizes]', s); wrap.innerHTML = ''; qa.vid = null;
    d.v.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = v.t; b.disabled = !v.a; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        qa.vid = v.id; $$('button', wrap).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        $('[data-qa-low]', s).textContent = (v.q >= 0 && v.q <= 10) ? 'Selling fast: only ' + v.q + ' left in ' + v.t : '';
        var add = $('[data-qa-add]', s); add.disabled = false; add.textContent = 'Add to bag · ' + inr(d.p);
      });
      wrap.appendChild(b);
    });
    var add = $('[data-qa-add]', s); add.disabled = true; add.textContent = 'Select a size'; $('[data-qa-low]', s).textContent = '';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ya-qa]');
    if (btn) {
      try { qa.data = JSON.parse(btn.getAttribute('data-sheet')); } catch (x) { return; }
      qa.btn = btn;
      if (qa.data.v.length === 1) { addToCart(qa.data.v[0].id, true); return; }
      renderQA(); paintEta(); openSheet('yaQA'); return;
    }
    var add = e.target.closest('[data-qa-add]');
    if (add && qa.vid) { add.disabled = true; add.textContent = 'Adding…'; addToCart(qa.vid, true).then(closeSheets); }
  });

  function paintWish() { var l = store.get('ya_wish'); $$('[data-ya-wish]').forEach(function (b) { b.classList.toggle('is-on', l.indexOf(b.getAttribute('data-ya-wish')) > -1); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ya-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-ya-wish'), l = store.get('ya_wish'), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    store.set('ya_wish', l); paintWish();
  });

  var hero = $('[data-ya-hero]');
  if (hero) {
    var track = $('.ya-hero__track', hero), dots = $$('.ya-hero__dots button', hero), cur = 0, tm;
    var go = function (n) { cur = (n + dots.length) % dots.length; track.style.transform = 'translateX(-' + (cur * 100) + '%)'; dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); }); };
    var start = function () { tm = setInterval(function () { go(cur + 1); }, 4500); };
    var reset = function () { clearInterval(tm); start(); };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); reset(); }); });
    if (!window.matchMedia('(prefers-reduced-motion:reduce)').matches) start();
    var sx = null; hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); reset(); } sx = null; });
  }

  var cf = $('[data-ya-comfort]');
  if (cf) {
    var imgs = $$('img', cf), sws = $$('.ya-sw button'), nm = $('[data-cf-name]', cf);
    sws.forEach(function (b, i) { b.addEventListener('click', function () {
      imgs.forEach(function (m, j) { m.classList.toggle('is-on', i === j); });
      sws.forEach(function (x, j) { x.classList.toggle('is-on', i === j); x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
      nm.textContent = b.getAttribute('data-name'); cf.setAttribute('href', b.getAttribute('data-url'));
    }); });
  }

  var cp = $('[data-ya-product]');
  if (cp) { var rv = store.get('ya_rv').filter(function (h) { return h !== cp.getAttribute('data-ya-product'); }); rv.unshift(cp.getAttribute('data-ya-product')); store.set('ya_rv', rv.slice(0, 12)); }
  function paintRecent() {
    var box = $('[data-ya-recent]'); if (!box) return;
    var curH = cp ? cp.getAttribute('data-ya-product') : '', list = store.get('ya_rv').filter(function (h) { return h !== curH; }).slice(0, 8);
    if (!list.length) { box.hidden = true; return; }
    var rail = $('.ya-rail', box);
    Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) { box.hidden = true; return; }
      rail.innerHTML = ps.map(function (p) { var im = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : ''; return '<a class="yac yac--rail yac--sm" style="--w:120px" href="' + p.url + '"><div class="yac__img"><img loading="lazy" src="' + im + '" alt=""></div><div class="yac__name">' + p.title.split(':')[0] + '</div><div class="yac__price"><b>' + inr(p.price) + '</b></div></a>'; }).join('');
      box.hidden = false;
    });
    var clr = $('[data-ya-clear]', box); if (clr) clr.addEventListener('click', function (e) { e.preventDefault(); store.set('ya_rv', curH ? [curH] : []); box.hidden = true; });
  }

  var coll = $('[data-ya-coll]'), bundle = null;
  if (coll) {
    try { bundle = JSON.parse(coll.getAttribute('data-bundle') || 'null'); } catch (e) { bundle = null; }
    var first = $('.yac', coll);
    if (bundle && first) bundle.unit = Math.round(first.dataset.price / 100); else bundle = null;
  }
  function priceFor(n) {
    var best = 0;
    bundle.tiers.forEach(function (x) { if (n >= x[0]) best = Math.max(best, x[0] * bundle.unit - x[1]); });
    return n * bundle.unit - best;
  }
  function paintCollection(c) {
    if (!coll) return;
    var mini = $('[data-ya-mini]');
    if (bundle) {
      var items = c.items.filter(function (i) { return i.handle.indexOf(bundle.match) > -1; });
      var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      var box = $('[data-ya-bundle]'), tiers = bundle.tiers.slice().sort(function (a, b) { return a[0] - b[0]; }), top = tiers[tiers.length - 1][0];
      var total = priceFor(n), save = n * bundle.unit - total, nextT = null;
      tiers.forEach(function (t) { if (!nextT && n < t[0]) nextT = t; });
      var one = bundle.noun.replace(/s$/, ''), msg;
      if (!nextT) msg = 'Best price unlocked. You save ' + inrR(save);
      else {
        var more = nextT[0] - n, gain = nextT[0] * bundle.unit - nextT[1];
        msg = (n > 0 && save > 0 ? 'You save ' + inrR(save) + '. ' : '') + (n === 0 ? 'Add any ' + nextT[0] + ' ' + bundle.noun + ' and save ' + inrR(gain) : 'Add ' + more + ' more ' + (more > 1 ? bundle.noun : one) + ' to save ' + inrR(gain));
      }
      $('[data-bundle-sum]', box).textContent = bundle.sum;
      $('[data-bundle-msg]', box).textContent = msg;
      $('[data-bundle-bar]', box).style.width = Math.min(100, n / top * 100) + '%';
      if (!box.querySelector('u')) { tiers.forEach(function (t) { if (t[0] < top) { var u = document.createElement('u'); u.style.left = (t[0] / top * 100) + '%'; $('.ya-bundle__bar', box).appendChild(u); } }); }
      if (mini) { if (n > 0) { mini.hidden = false; $('[data-mini-t]', mini).textContent = n + ' ' + (n === 1 ? one : bundle.noun) + ' in bag · ' + inrR(total); $('[data-mini-s]', mini).textContent = save > 0 ? 'You save ' + inrR(save) : msg; } else mini.hidden = true; }
    } else if (mini) {
      if (c.item_count > 0) { mini.hidden = false; $('[data-mini-t]', mini).textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in bag · ' + inr(c.total_price); $('[data-mini-s]', mini).textContent = c.total_discount > 0 ? 'You save ' + inr(c.total_discount) : 'Free shipping on prepaid'; } else mini.hidden = true;
    }
    $$('.yac__qa').forEach(function (b) {
      var h = b.closest('.yac').getAttribute('data-handle'), q = c.items.filter(function (i) { return i.handle === h; });
      if (q.length) { b.classList.add('is-in'); b.textContent = 'In bag (' + q.map(function (i) { return i.variant_title; }).join(', ') + ') · Add more'; }
    });
  }
  if (coll) api.onCart.push(paintCollection);

  var grid = $('[data-ya-grid]');
  if (grid) {
    var sortKey = 'manual', orig = $$('.yac', grid), sizeSel = [], onlyIn = false;
    var apply = function () {
      var arr = orig.slice();
      if (sortKey === 'low') arr.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (sortKey === 'high') arr.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      if (sortKey === 'new') arr.sort(function (a, b) { return b.dataset.date - a.dataset.date; });
      arr.forEach(function (c) { var sz = (c.dataset.sizes || '').split(','); var ok = (!sizeSel.length || sizeSel.some(function (s) { return sz.indexOf(s) > -1; })) && (!onlyIn || sz[0] !== ''); c.style.display = ok ? '' : 'none'; grid.appendChild(c); });
      var lab = { manual: 'Bestselling', low: 'Price: low to high', high: 'Price: high to low', 'new': 'Newest' }[sortKey];
      $('[data-sort-label]').textContent = 'Sort: ' + lab;
      $('[data-filter-label]').textContent = (sizeSel.length || onlyIn) ? 'Filter · ' + (sizeSel.length + (onlyIn ? 1 : 0)) : 'Filter';
    };
    var opt = function (title, items, cb) {
      $('[data-opt-title]').textContent = title; var l = $('[data-opt-list]'); l.innerHTML = '';
      items.forEach(function (it) { var b = document.createElement('button'); b.type = 'button'; b.textContent = it.t; if (it.on) b.classList.add('is-on'); b.addEventListener('click', function () { cb(it, b); }); l.appendChild(b); });
      openSheet('yaOpt');
    };
    $('[data-ya-sort]').addEventListener('click', function () {
      var defs = [['manual', 'Bestselling'], ['new', 'Newest'], ['low', 'Price: low to high'], ['high', 'Price: high to low']];
      opt('Sort by', defs.map(function (d) { return { k: d[0], t: d[1], on: sortKey === d[0] }; }), function (it) { sortKey = it.k; apply(); closeSheets(); });
    });
    $('[data-ya-filter]').addEventListener('click', function () {
      var all = {}; orig.forEach(function (c) { (c.dataset.sizes || '').split(',').forEach(function (s) { if (s) all[s] = 1; }); });
      var order = ['XS', 'S', 'M', 'L', 'XL', '2XL'], sizes = Object.keys(all).sort(function (a, b) { var x = order.indexOf(a), y = order.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); });
      var rows = [{ t: 'In stock only', inStock: true, on: onlyIn }].concat(sizes.map(function (s) { return { t: 'Size ' + s, s: s, on: sizeSel.indexOf(s) > -1 }; })).concat([{ t: 'Clear filters', clear: true }]);
      opt('Filter', rows, function (it, b) {
        if (it.clear) { sizeSel = []; onlyIn = false; apply(); closeSheets(); return; }
        if (it.inStock) { onlyIn = !onlyIn; it.on = onlyIn; } else { var i = sizeSel.indexOf(it.s); if (i > -1) sizeSel.splice(i, 1); else sizeSel.push(it.s); it.on = i < 0; }
        b.classList.toggle('is-on', it.on); apply();
      });
    });
  }
  var mb = $('[data-ya-mini] button'); if (mb) mb.addEventListener('click', function () { var d = document.querySelector('cart-drawer'); if (d && d.refresh) d.refresh().then(function () { d.open(); }); });

  function init() { paintEta(); paintWish(); paintRecent(); api.refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();